import validator from 'validator';

/**
 * @param {Object[]} fields
 * @param {anything} fields[].value to validate
 * @param {string} fields[].type of the value
 * @param {boolean} fields[].empty true if the value can pe empty - not required
 * @returns {string[]} errors if there are any
 */
function validate(fields) {
  let errors = [];
  const len = fields.length;
  for (let i = 0; i < len; i++) {
    const {value, type, empty} = fields[i];
    errors.push('');

    if ((!empty && !value) || value === undefined) {
      errors[i] = 'Empty field ' + type;
      continue;
    }

    const timestampRegex = /[1-2]\d{3}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d+Z)?/;  // 2021-12-03T14:53:30.344Z

    switch (type) {
      case 'url':
        if (!validator.isURL(value, {
          protocols: ['http','https'],
          allow_underscores: true,
          allow_query_components: false,
          allow_fragments: false
        })) errors[i] = 'Not a valid URL';
        break;
      case 'select':
        if (!Object.keys(value).find(key => value[key])) errors[i] = 'Select at least one item';
        break;
      case 'db_microservice_id':
        break;
      case 'db_microservice_fetchers':
        if (!Array.isArray(value)) errors[i] = 'The microservice fetchers must be stored in array';
        else if (value.filter(fetcher =>
          typeof fetcher.name !== 'string' ||
          typeof fetcher.info !== 'string' ||
          (fetcher.status !== -1 && fetcher.status !== 0 && fetcher.status !== 1) ||
          typeof fetcher.types !== 'object'
        ).length !== 0)
          errors[i] = 'The microservice fetcher data structure does not correspond to our standards';
        break;
      case 'db_microservice_status':
        if (value !== -1 && value !== 0 && value !== 1) errors[i] = 'The microservice status value does not correspond to our standards';
        break;
      case 'db_microservice_host':
        if (typeof value !== 'string') errors[i] = 'The microservice host data structure does not correspond to our standards';
        else if (!validator.isURL(value, {
          protocols: ['http','https'],
          allow_underscores: true,
          allow_query_components: false,
          allow_fragments: false
        })) errors[i] = 'The microservice host is not URL';
        break;
      case 'db_microservice_uri':
        if (typeof value !== 'string') errors[i] = 'The microservice URI data structure does not correspond to our standards';
        else if (!validator.isURL(value, {
          protocols: ['http','https'],
          allow_underscores: true,
          allow_query_components: false,
          allow_fragments: false
        })) errors[i] = 'The microservice URI is not URL';
        break;
      case 'db_microservice_version':
        if (typeof value !== 'string') errors[i] = 'The microservice version data structure does not correspond to our standards';
        break;
      case 'db_microservice_groups':
        if (!Array.isArray(value) || value.find(group => typeof group !== 'string'))
          errors[i] = 'The microservice groups data structure does not correspond to our standards';
        break;
      case 'db_microservice_author':
        if (typeof value !== 'string') errors[i] = 'The microservice author data structure does not correspond to our standards';
        break;
      case 'db_microservice_name':
        if (typeof value !== 'string') errors[i] = 'The microservice name data structure does not correspond to our standards';
        break;
      case 'db_microservice_CreatedAt':
        if (typeof value !== 'string' || !value.match(timestampRegex)) errors[i] = 'The microservice CreatedAt does not correspond to our standards';
        break;
      case 'db_microservice_UpdatedAt':
        if (typeof value !== 'string' || !value.match(timestampRegex)) errors[i] = 'The microservice UpdatedAt does not correspond to our standards';
        break;
      case 'username':  // TODO keycloak
        if (!validator.isAlphanumeric(value)) errors[i] = 'The username must contain only letters and numbers';
        break;
      case 'email':
        if (!validator.isEmail(value)) errors[i] = 'Not a valid email';
        break;
      case 'password':
        if (!validator.isStrongPassword(value)) errors[i] = 'Not a strong password';
        break;
      case 'confirmPassword':
        const {password, confirm} = value;
        if (password !== confirm) errors[i] = 'The passwords do not match';
        break;
      case 'db_user_id':
        break;
      case 'db_user_username':
        if (typeof value !== 'string') errors[i] = 'The username data structure does not correspond to our standards';
        break;
      case 'db_user_email':
        if (typeof value !== 'string') errors[i] = 'The email data structure does not correspond to our standards';
        break;
      case 'db_user_groups':
        if (!Array.isArray(value)) errors[i] = 'The user groups data structure does not correspond to our standards';
        break;
      case 'db_user_roles':
        if (!Array.isArray(value)) errors[i] = 'The user roles data structure does not correspond to our standards';
        break;
      case 'db_user_enabled':
        if (typeof value !== 'boolean') errors[i] = 'The user enabled data structure does not correspond to our standards';
        break;
      case 'group_name':  // TODO keycloak
        if (!validator.isAlphanumeric(value)) errors[i] = 'The group name must contain only letters and numbers';
        break;
      case 'db_group_id':
        break;
      case 'db_group_name':
        break;
      case 'db_group_path':
        break;
      case 'db_group_subgroups':
        break;
      case 'db_case_id':
        break;
      case 'db_case_nodes':
        break;
      case 'db_case_edges':
        break;
      case 'db_case_name':
        break;
      case 'db_case_created_at':
        break;
      case 'db_case_updated_at':
        break;
      case 'caseName':
        if (!validator.isAscii(value)) errors[i] = 'The case name must contain only ASCII characters.';
        break;
      default:
        errors[i] = 'Unknown error';
        break;
    }
  }
  return errors;
}

export default validate;